import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {FirebaseService} from '../Services/Firebase/firebase.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css',]
})
export class LandingComponent implements OnInit {
  countryReq: string;

  constructor(private firebase: FirebaseService, private router: Router) { }
  ngOnInit() {
    this.firebase.fetchActivate().then(() => {
      this.getCountry();
    });
  }
  async getCountry() {
    this.countryReq = await this.firebase.getStringRC('country_validation');
    //this.countryReq = 'HN';
    console.log('country_validation' + this.countryReq);
  }

  goToLogin() {
    /*if (this.countryReq === 'SV') {
      window.location.href = 'https://rpnold.mediprocesos.com/login';
    } else {
    }*/
    this.router.navigate(['login']);
  }

  goToProvidersNetwork() {
    /*if (this.countryReq === 'SV') {
      window.location.href = 'https://rpnold.mediprocesos.com/login';
    } else {
    }*/
    //this.router.navigate(['login']);
    window.location.href = 'https://providers.mediprocesos.com/';
  }
}
